const initialState = {
  paymentResp: null,
  refundResp:null
}

const authorizenetToken = (state = initialState, action) => {
  switch (action.type) {
    case 'PAYMENT_RESPONSE':
      return { ...state, paymentResp: action.data }
    case 'REFUND_RESPONSE':
      return { ...state, refundResp: action.data }
    default:
      return { ...state }
  }
}
export default authorizenetToken
